<template>
    <li
        class="contact-search-header"
        :class="{ 'sem-atendimentos': semAtendimentos, 'anima-entrada': atrasoEntrada != null, 'anima-saida': saindo }"
        :style="atrasoEntrada != null && !saindo ? { animationDelay: `${atrasoEntrada}ms` } : undefined"
    >
        <p v-if="semAtendimentos" class="text-muted font-size-12 mb-2 text-center">Nenhum atendimento encontrado.</p>
        <div class="d-flex align-items-center gap-2">
            <span class="contact-search-header-title">Contatos</span>
            <span class="contact-search-header-line flex-grow-1"></span>
        </div>
    </li>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { atrasoNaMontagem, EntradaEmCascata } from '@/utils/animacaoEntrada';

const props = defineProps({
    semAtendimentos: { type: Boolean, default: false },
    entrada: { type: Object as PropType<EntradaEmCascata | null>, default: null },
    saindo: { type: Boolean, default: false },
});

/** Decidido na montagem: o cabeçalho remontado pelo scroll não repete a entrada. */
const atrasoEntrada = atrasoNaMontagem(props.entrada);
</script>

<style scoped>
.contact-search-header {
    list-style: none;
    height: 44px;
    padding: 14px 10px 0;
}
.contact-search-header.sem-atendimentos {
    height: 72px;
}
.contact-search-header-title {
    font-size: 11px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: var(--bs-primary);
}
.contact-search-header-line {
    height: 1px;
    background-color: var(--bs-border-color);
}

.anima-entrada { animation: cabecalho-entra 0.28s ease-out both; }
.anima-saida { animation: cabecalho-sai 0.18s ease-in forwards; }
@keyframes cabecalho-entra { from { opacity: 0; } to { opacity: 1; } }
@keyframes cabecalho-sai { from { opacity: 1; } to { opacity: 0; } }
@media (prefers-reduced-motion: reduce) {
    .anima-entrada, .anima-saida { animation-duration: 0.01ms; }
}
</style>
